import { BaseDto } from "@models/base/baseDto.model";

export class UpdateTipoMovimientoRequest extends BaseDto{
    public resta!: boolean
    public editable!: boolean
    public esAnulable!: boolean
}
